import {
  ChromeData,
  fetchChromeData,
  ForbiddenError,
} from '@amzn/aac-chrome-internal-api';
import ChromeInternalApiRequestConfig from './chrome-internal-api-request-config';

export default async (): Promise<ChromeData> => {
  try {
    if (window.AACChrome?.InternalAPI) {
      return window.AACChrome.InternalAPI.ChromedDataHandler.getInstance().getChromeData(
        ChromeInternalApiRequestConfig,
      );
    }
    return fetchChromeData(ChromeInternalApiRequestConfig);
  } catch (error: any) {
    // redirect to login page if the API returns 403
    if (window && error && error.type === ForbiddenError.TYPE) {
      window.location.replace(error.loginUrl);
    }
    throw error;
  }
};
